uniform vec3 uColor;
uniform sampler2D uTexture;
uniform vec3 uLightPosition;

varying vec2 vUv;
varying float vElevation;
varying vec3 vNormal;
varying vec3 vPosition;

void main()
{
    // Texture color
    vec4 textureColor = texture2D(uTexture, vUv);

    // Normal
    vec3 normal = normalize(vNormal);

    // Light direction
    vec3 lightDir = normalize(uLightPosition - vPosition);

    // Diffuse lighting
    float diff = max(dot(normal, lightDir), 0.0);
    diff = diff * 0.6 + 0.4;

    // Elevation shading - burmalar uchun
    float shadow = smoothstep(-0.2, 0.2, vElevation) * 0.4 + 0.6;

    // Final color
    vec3 finalColor = textureColor.rgb * diff * shadow;

    // Biroz yorqinlik
    finalColor *= 1.1;

    gl_FragColor = vec4(finalColor, 1.0);
}
